import type { AppointmentFilters } from '../api/appointments';

interface ApiFilter {
    fieldName: string;
    operator: string;
    value: string;
    type: string;
    urlCode: string;
}

/**
 * Build filter array for appointments API from filter params
 */
export function buildAppointmentFilters(filters: AppointmentFilters): ApiFilter[] {
    const filterArray: ApiFilter[] = [];

    // Add date filters if startDate and endDate are provided
    if (filters.startDate && filters.endDate) {
        filterArray.push(
            {
                fieldName: 'booking-start',
                operator: '>=',
                value: filters.startDate,
                type: 'date',
                urlCode: 'gte',
            },
            {
                fieldName: 'booking-start',
                operator: '<=',
                value: filters.endDate,
                type: 'date',
                urlCode: 'lte',
            }
        );
    }

    // Add status filter if provided
    if (filters.bookingStatus !== undefined) {
        filterArray.push({
            fieldName: 'booking-status',
            operator: '=',
            value: String(filters.bookingStatus),
            type: 'select',
            urlCode: 'eq',
        });
    }

    return filterArray;
}
